/* eslint-disable no-nested-ternary */
import {
  Box, Button, Stack, Tooltip, Typography,
} from '@mui/material';
import * as Yup from 'yup';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import EditNoteIcon from '@mui/icons-material/Edit';
import { exportData } from '../../../utils/methods';
import { CustomIcon } from '../../../components/CustomIcon';
import useToggle from '../../../hooks/useToggle';
import { FormDialogBox } from '../../../components/CustomDialogBox';
import CustomFilterForm from './CustomFilter/CustomFilterForm';
import useCustomFilter from './useCustomFilter';

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .max(25, 'Name must be at most 25 characters')
    .required('Enter a name for Account View'),
});

function AccountListHeader(props) {
  const {
    classes,
    accountList,
    selectedView,
    setSelectedView,
    findSelectedView,
    isLicense = true,
  } = props;

  const [open, setOpen] = useToggle();

  const {
    handleEdit,
    getInitialValues,
    handleDelete,
  } = useCustomFilter({
    selectedView,
    setSelectedView,
    findSelectedView,
  });

  const selectedAccountListSubMenu = findSelectedView(selectedView);

  return (
    <Box className={classes.headerStyles}>
      <Box className="tg-filter-view">
        <Stack
          direction="row"
          alignItems="center"
          sx={{ width: 'max-content', borderRadius: '6px' }}
        >
          <Typography variant="h4">
            {
              !isLicense
                ? 'Active Accounts'
                : selectedAccountListSubMenu
                  ? selectedAccountListSubMenu.name
                  : 'Active Licenses'
            }
          </Typography>
          {selectedAccountListSubMenu && <CustomIcon sxProps={{ ml: '4px' }} Icon={EditNoteIcon} size="small" onClick={setOpen} />}
        </Stack>
        <Typography sx={{ ml: '2px', fontSize: 14, color: (theme) => theme.palette.secondary.mainColor }}>
          {accountList ? `${accountList.length} ${isLicense ? 'Licenses' : 'Accounts'}` : 'Loading...'}
        </Typography>
      </Box>

      <Box>
        <Tooltip title="Export filtered accounts list as excel">
          <Button
            className="tg-export-list"
            variant="outlined"
            endIcon={<FileDownloadIcon color="primary" fontSize="small" />}
            onClick={() => exportData('Accounts', accountList)}
          >
            Export
          </Button>
        </Tooltip>
      </Box>

      <FormDialogBox
        title="Edit Account View"
        open={open}
        handleClose={setOpen}
        onSubmit={(values) => {
          handleEdit(values);
          setOpen();
        }}
        initialValues={getInitialValues()}
        validationSchema={validationSchema}
        formContent={<CustomFilterForm />}
        formAction={[
          {
            label: 'Delete',
            size: 'small',
            variant: 'outlined',
            onClick: () => {
              handleDelete();
              setOpen();
            },
          },
          {
            label: 'Update',
            size: 'small',
            type: 'submit',
          },
        ]}
      />
    </Box>
  );
}

export default AccountListHeader;
